import { OPEN_IMAGE_MODAL, CLOSE_IMAGE_MODAL } from "../constants/imageModal";
import $S from '../theme/settings'

const {
  packageOrderDetailModalImageHeight: height,
  packageOrderDetailModalImageWidth: width
} = $S;

const initialState = {
  visible: false,
  image: null,
  width,
  height
};

export const imageModal = (state = initialState, action) => {
  switch (action.type) {
    case OPEN_IMAGE_MODAL:
      return {
        ...state,
        visible: true,
        image: action.data.image,
        width: action.data.width || initialState.width,
        height: action.data.height || initialState.height
      };

    case CLOSE_IMAGE_MODAL:
      return { ...initialState };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/imageModal.js